<button 
    size="small" 
    p-button  
    [pTooltip]="data.length > 0 ? tooltipContent : ''" 
    tooltipPosition="bottom" 
    class="ml-3 split-button-orange-1" 
    [class.active]="data.length > 0" 
    type="button" 
    (click)="showOverlayPanel($event)">
    {{label}}
</button>
<p-overlayPanel #op (onHide)="hideOverlayPanel()" appendTo="body">
    <div class="split-dropdown-panel">
        <div class="split-dropdown-header">
            <split-search  class="w-full" [value]="value" (valueChange)="setValue($event)"></split-search>
        </div>
        <div class="split-dropdown-footer">
            <p-button (click)="onEmit()" label="aplicar"></p-button>
        </div>
      </div>
</p-overlayPanel>

<ng-template #tooltipContent>
   <p class="my-1">Filtros selecionados: </p>
   <div class="flex align-items-center justify-content-center">
        <span>{{_data[0] }}</span>
   </div>
</ng-template>